import { useState } from "react";

import { percentUiToDecimals, percentDecimalsToUi } from "@bridgesplit/utils";
import { DialogWrapper, LabelWrapper, Button } from "@bridgesplit/ui";
import { AppDialog, useAppDialog } from "app/utils";
import { HeaderWithClose, Slippage, SlippageValue } from "app/components/common";
import { COPY } from "app/constants";

export function VaultWithdrawSlippageDialog() {
    const { getData, close } = useAppDialog();

    const data = getData(AppDialog.VaultWithdrawSlippage);
    const [slippageUi, setSlippageUi] = useState<SlippageValue | undefined>(percentDecimalsToUi(data?.slippageSetting));

    return (
        <DialogWrapper>
            <HeaderWithClose header={COPY.VAULT_WITHDRAW_SETTINGS} close={close} />
            <LabelWrapper label="Slippage" tooltip={COPY.SLIPPAGE_TOOLTIP}>
                <Slippage.Input
                    value={slippageUi}
                    presets={[0, 0.01, 0.1]}
                    setValue={(val: SlippageValue | undefined) => {
                        if (val === undefined) return;
                        if (typeof val === "number") {
                            setSlippageUi(val);
                        }
                    }}
                />
            </LabelWrapper>
            <Button
                disabled={slippageUi === undefined}
                variant="contained"
                onClick={() => {
                    if (slippageUi === undefined) return;
                    if (typeof slippageUi === "number") {
                        data?.setSlippageSetting(percentUiToDecimals(slippageUi));
                    }
                    close();
                }}
            >
                Save setting
            </Button>
        </DialogWrapper>
    );
}
